import { IMAGE_SIZES_AVAILABLE } from './constants';
import { isEpsImage } from './isEpsImage';
import { isEpsFormat, isZoomFormat } from './utils';
/**
 * Check if an image a valid EPS image given its URL and size.
 * @param url - URL of the image
 * @param size - size in pixel of the image
 * @returns True if it is a valid EPS image
 */
export const isValidEpsUrl = (url, size) => isEpsImage(url.href) &&
    IMAGE_SIZES_AVAILABLE.includes(size) &&
    (isEpsFormat(url.href) || isZoomFormat(url.href));
